import React from "react";
// React Table
import { Container, Row, Col, Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";
//112022 para mostrar los ámbitos enteros
import { ambitosObras } from "../../../../contexto";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaAmbitos = ({ datosAmbitos }) => {
  return (
    <Container>
      <Row>
        <Col>
          {datosAmbitos.length ? (
            <Container>
              <lu>
                {datosAmbitos.map((ambito) => (
                  <li>{ambitosObras[ambito.type]}</li>
                ))}
              </lu>
            </Container>
          ) : (
            <p>Esta obra no tiene asignado ningún ámbito actualmente actualmente.</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default VistaAmbitos;
